import IntroDeals from './IntroDeals'

export * from './IntroDeals'

export default IntroDeals
